var _circle, _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgSms(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 67,
    height: 67,
    viewBox: "0 0 67 67",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 33.1724,
    cy: 33.1724,
    r: 32.1724,
    fill: "#F1E9FA",
    stroke: "white",
    strokeWidth: 2
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M42.5234 21.7795C43.1663 21.7795 43.717 22.0084 44.1748 22.4661C44.6326 22.9239 44.8613 23.4745 44.8613 24.1174V39.8987C44.8613 40.5415 44.6326 41.0922 44.1748 41.55C43.717 42.0077 43.1662 42.2366 42.5234 42.2366H25.6885L21.4824 46.3274V24.1174C21.4824 23.4746 21.7112 22.9239 22.1689 22.4661C22.6267 22.0083 23.1775 21.7796 23.8203 21.7795H42.5234ZM26.1582 33.1721V36.679H34.3408V33.1721H26.1582ZM26.1582 27.3274V30.8342H40.1855V27.3274H26.1582Z",
    fill: "#9B51E0"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSms);
export default __webpack_public_path__ + "static/media/sms.bcd73bcfac9786edc0189fb6fdea165d.svg";
export { ForwardRef as ReactComponent };